export const GET_PAY_TOKEN_SUCCESS = 'GET_PAY_TOKEN_SUCCESS';
export const GET_PAY_TOKEN_ERROR = 'GET_PAY_TOKEN_ERROR';
export const ASSIGN_PAY_SUCCESS = 'ASSIGN_PAY_SUCCESS';
export const ASSIGN_PAY_LOADING = 'ASSIGN_PAY_LOADING';
export const CHNAGE_PLAN_ID_SUCCESS = 'CHNAGE_PLAN_ID_SUCCESS';
export const REACTIVATE_SUBSCRIPTION_SUCCESS = 'REACTIVATE_SUBSCRIPTION_SUCCESS';
